import { useQuery } from 'react-query';
import { productService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useCheckIsIDSStoreDisabled = () => {
  return useQuery(
    ServerStateKeysEnum.isIDSStoreDisabled,
    () => productService.isIDSStoreDisabled(),
    {
      staleTime: Infinity,
    }
  );
};
